module.exports = __webpack_public_path__ + "img/instagram-icon-white.24dd0183.svg";